export default {
    panels: "panels",
    regions: "regions",
};
